const ESignJLLTConfigModule = {
    namespaced: true,
    state: {
        esignConfig: null,
        esignConfigItems: null,
        configLoading: true,
        configItemsLoading: true,
    },
    actions: {
        SET_ESIGN_CONFIG({ state, commit }, esignConfig) {
            commit("SetESignConfig", esignConfig);
        },
        SET_ESIGN_CONFIG_ITEMS({ state, commit }, esignConfigItems) {
            commit("SetESignConfigItems", esignConfigItems.map((item) => ({...item, ITEMS: JSON.parse(item.ITEMS)})))
        },
    },
    mutations: {
        SetESignConfig: function (state, esignConfig) {
            state.esignConfig = esignConfig;
            state.configLoading = false;
        },
        SetESignConfigItems: function (state, esignConfigItems) {
            state.esignConfig.SIGNEES = esignConfigItems.filter(
                ({ TypeOfItem }) => TypeOfItem === "Signer"
            );

            state.esignConfig.APPROVERS = esignConfigItems.filter(
                ({ TypeOfItem }) => TypeOfItem === "Approver"
            );
            state.configItemsLoading = false;
        },
    },
    getters: {
        GetESignConfig: function (state) {
            try {
                return state.esignConfig;
            } catch (err) {
                return null;
            }
        },
        ESignConfigLoaded: function (state) {
            return state.esignConfig != null;
        },
        ESignConfigLoading: function (state) {
            return state.configLoading || state.configItemsLoading;
        },
        ///
        ///

        GetRegions: function (state) {
            return (
                state.esignConfig?.LEGAL_ENTITIES?.REGIONS?.filter(({ ISDELETED }) => {
                    return !ISDELETED;
                }) || []
            );
        },
        GetRegionsSelect: function (state, getters) {
            return (
                getters.GetRegions
                    ?.map(({ NAME, CODE, DEFAULT }) => {
                        return { name: NAME, code: CODE, default: DEFAULT };
                    })
                    .sort((a, b) => a.name.localeCompare(b.name)) || []
            );
        },

        GetCountry: function (state, getters) {
            return (country) =>
                getters
                    .GetCountries(null, true)
                    .find(({ CODE }) => country === CODE)
                    .filter(({ ISDELETED }) => {
                        return !ISDELETED;
                    });
        },

        GetCountries: function (state, getters) {
            return (region, all) =>
                all
                    ? getters.GetRegions.reduce(
                        (p, c, v) => p.concat(c.COUNTRIES || []),
                        []
                    )
                    : getters.GetRegions?.filter((x) => x.CODE == region)
                        .reduce((p, c, v) => p.concat(c.COUNTRIES || []), [])
                        ?.filter(({ ISDELETED }) => {
                            return !ISDELETED;
                        })
        },

        GetCountriesSelect: function (state, getters) {
            return (region) => {
                return (
                    getters.GetCountries(region).map(({ NAME, CODE, DEFAULT, ALLOW_EXTERNAL_APPROVAL }) => {
                        return { name: NAME, code: CODE, default: DEFAULT, allowExternalApproval: ALLOW_EXTERNAL_APPROVAL, };
                    })?.sort((a, b) => a.name.localeCompare(b.name)) || []
                );
            };
        },

        GetLegalEntity: function (state, getters) {
            return (legalEntity, country, region) =>
                getters
                    .GetLegalEntities(region, country)
                    .find(({ CODE }) => legalEntity === CODE);
        },

        GetLegalEntities: function (state, getters) {
            return (region, country, all) =>
                all
                    ? getters
                        .GetCountries(region, all)
                        .reduce((p, c, v) => p.concat(c.LEGAL_ENTITIES || []), [])
                    : getters
                        .GetCountries(region)
                        ?.filter((x) => x.CODE == country)
                        .reduce((p, c, v) => p.concat(c.LEGAL_ENTITIES || []), [])
                        .filter(({ ISDELETED }) => {
                            return !ISDELETED;
                        });
        },

        GetLegalEntitiesSelect: function (state, getters) {
            return (region, country, all) =>
                getters
                    .GetLegalEntities(region, country, all)
                    .map(({ NAME, CODE, DEFAULT }) => {
                        return { name: NAME, code: CODE, default: DEFAULT };
                    })?.sort((a, b) => a.name.localeCompare(b.name)) || [];
        },

        GetAreas: function (state) {
            return (country, legalEntity, all) => {
                if (all) {
                    return (
                        state.esignConfig?.LEGAL_ENTITIES?.AREAS?.filter(
                            ({ ISDELETED }) => {
                                return !ISDELETED;
                            }
                        ) || []
                    );
                }

                return (
                    state.esignConfig?.LEGAL_ENTITIES?.AREAS?.filter(
                        (x) =>
                            (!country || x.COUNTRY === null || x.COUNTRY.includes(country)) &&
                            (!legalEntity ||
                                x.LEGAL_ENTITY === null ||
                                x.LEGAL_ENTITY.includes(legalEntity))
                    )?.filter(({ ISDELETED }) => {
                        return !ISDELETED;
                    }) || []
                );
            };
        },

        GetAreasSelect: function (state, getters) {
            return (country, legalEntity) =>
                getters
                    .GetAreas(country, legalEntity)
                    .map(({ NAME, CODE, DEFAULT }) => {
                        return { name: NAME, code: CODE, default: DEFAULT };
                    })?.sort((a, b) => a.name.localeCompare(b.name)) || [];
        },

        GetSegments: function (state, getters) {
            return (country, legalEntity, area, all) => {
                if (all) {
                    return (
                        state.esignConfig?.LEGAL_ENTITIES?.SEGMENTS?.filter(
                            ({ ISDELETED }) => {
                                return !ISDELETED;
                            }
                        ) || []
                    );
                }
                return (
                    state.esignConfig?.LEGAL_ENTITIES?.SEGMENTS?.filter(
                        (x) =>
                            (!country || x.COUNTRY === null || x.COUNTRY.includes(country)) &&
                            (!legalEntity ||
                                x.LEGAL_ENTITY === null ||
                                x.LEGAL_ENTITY.includes(legalEntity)) &&
                            (!area || x.AREA === null || x.AREA.includes(area))
                    )?.filter(({ ISDELETED }) => {
                        return !ISDELETED;
                    }) || []
                );
            };
        },

        GetSegmentsSelect: function (state, getters) {
            return (country, legalEntity, area) => {
                return (
                    getters
                        .GetSegments(country, legalEntity, area)
                        .map(({ NAME, CODE, DEFAULT }) => {
                            return { name: NAME, code: CODE, default: DEFAULT };
                        })?.sort((a, b) => a.name.localeCompare(b.name)) || []
                );
            };
        },

        GetSubsegments: function (state) {
            return (country, legalEntity, area, segment, all) => {
                if (all) {
                    return (
                        state.esignConfig?.LEGAL_ENTITIES?.SUBSEGMENTS?.filter(
                            ({ ISDELETED }) => {
                                return !ISDELETED;
                            }
                        ) || []
                    );
                }
                return (
                    state.esignConfig?.LEGAL_ENTITIES?.SUBSEGMENTS?.filter(
                        (x) =>
                            (!country || x.COUNTRY === null || x.COUNTRY.includes(country)) &&
                            (!legalEntity ||
                                x.LEGAL_ENTITY === null ||
                                x.LEGAL_ENTITY.includes(legalEntity)) &&
                            (!area || x.AREA === null || x.AREA.includes(area)) &&
                            (!segment || x.SEGMENT === null || x.SEGMENT.includes(segment))
                    )?.filter(({ ISDELETED }) => {
                        return !ISDELETED;
                    }) || []
                );
            };
        },

        GetSubsegmentsSelect: function (state, getters) {
            return (country, legalEntity, area, segment) => {
                return (
                    getters
                        .GetSubsegments(country, legalEntity, area, segment)
                        .map(({ NAME, CODE, DEFAULT }) => {
                            return { name: NAME, code: CODE, default: DEFAULT };
                        })?.sort((a, b) => a.name.localeCompare(b.name)) || []
                );
            };
        },

        GetCounterParties: function (state) {
            return state.esignConfig?.COUNTERPARTY?.COUNTER_TYPES;
        },

        GetCounterPartiesSelect: function (state, getters) {
            return (
                getters.GetCounterParties?.map(({ NAME, VALUE }) => {
                    return { name: NAME, code: VALUE };
                }) || []
            );
        },

        GetContractType: function (state, getters) {
            return (contractType, counterParty) =>
                getters
                    .GetContractTypes(counterParty)
                    ?.find(({ VALUE }) => contractType === VALUE);
        },

        GetContractTypes: function (state) {
            return (counterParty) =>
                state.esignConfig?.CONTRACT_TYPES?.CONTRACT_TYPES?.find(
                    (ct) => ct.COUNTERPARTY == counterParty
                )?.CONTRACT_TYPE_LIST || [];
        },

        GetContractTypesSelect: function (state, getters) {
            return (counterParty) =>
                getters.GetContractTypes(counterParty)?.map(({ NAME, VALUE }) => {
                    return { name: NAME, code: VALUE };
                })?.sort((a, b) => a.name.localeCompare(b.name)) || [];
        },

        GetContractGroup: function (state) {
            return state.esignConfig?.CONTRACT_TYPES?.CONTRACT_TYPE_GROUPS || [];
        },

        GetContactGroupSelect: function (state, getters) {
            return (
                getters.GetContractGroup.map(({ NAME, VALUE }) => {
                    return { name: NAME, code: VALUE };
                }) || []
            );
        },

        GetFeesRanges: function (state) {
            return state.esignConfig?.FEES || [];
        },

        GetFeesRangesSelect: function (state, getters) {
            return (
                getters.GetFeesRanges?.map(({ NAME, VALUE, MIN, MAX }) => {
                    return { name: NAME, code: VALUE, min: MIN, max: MAX };
                }) || []
            );
        },

        GetStoplightApprovals: function (state) {
            return state.esignConfig?.APPROVAL_PROCESS?.STOPLIGHT_APPROVALS || [];
        },

        GetStoplightApprovalsSelects: function (state, getters) {
            return (contractTypeValue, counterPartyValue) => {
                let contractType = getters.GetContractType(contractTypeValue, counterPartyValue);
                if (contractType?.DISABLE_STOPLIGHTS){
                    return [];
                }
                else {
                    return getters.GetStoplightApprovals?.map((slApproval) => {
                        return {
                            code: slApproval.CODE,
                            name: slApproval.NAME,
                            default: slApproval.DEFAULT,
                            values: slApproval.VALUES?.map(
                                ({ CODE, LABEL, RISK_COLOR, APPROVAL }) => {
                                    return {
                                        code: CODE,
                                        name: LABEL,
                                        color: RISK_COLOR,
                                        hasApprovals: !!APPROVAL?.length,
                                    };
                                }
                            ),
                            tooltip: slApproval.TOOLTIP,
                        };
                    }) || []
                }
            };
        },

        GetApprovers: function (state) {
            return state.esignConfig?.APPROVAL_PROCESS?.APPROVERS;
        },

        GetApprover: function (state, getters) {
            return (code) => getters.GetApprovers?.find(({ CODE }) => CODE === code);
        },

        GetApproversSelects: function (state, getters) {
            let selects = (approvalStoplightsSelected,
                region,
                country,
                area,
                segment,
                subsegment,
                contractType,
                contractPrice,
                tags
            ) => {
                if (
                    !area ||
                    !segment ||
                    !subsegment ||  
                    !country ||
                    !state.esignConfig?.APPROVERS ||
                    !getters.GetStoplightApprovals
                ) {
                    return [];
                } else {
                    var onlyGreen = Object.entries(approvalStoplightsSelected).every(
                        ([_, val]) => val?.stoplight?.hasApprovals
                    );
                    return getRequiredApprovals(
                        state?.esignConfig?.APPROVERS,
                        getters.GetApprovers,
                        getters.GetStoplightApprovals,
                        approvalStoplightsSelected,
                        area,
                        segment,
                        subsegment,
                        country,
                        tags
                    ).filter(
                        (app) =>
                            !app.roleApproval &&
                            (
                                app.mandatory ||
                                app.approval ||
                                app.canBeDelegated ||
                                (app.onlyGreen && onlyGreen)
                            ) &&
                            !app.tags || app.tags?.every((tag) => tags?.includes(tag))
                    );
                }
            };
            return selects;
        },

        GetSignees: function (state) {
            return (
                region,
                country,
                area,
                segment,
                subsegment,
                contractType,
                contractPrice,
                tags
            ) => {
                if (
                    !region ||
                    !country ||
                    !area ||
                    !segment ||
                    !subsegment ||
                    !contractType ||
                    !contractPrice ||
                    !tags
                ) {
                    return [];
                }

                let filteredItems = state.esignConfig?.SIGNEES?.filter(
                    ({ FILTERS, EXCEPTIONS }) =>
                        FILTERS.some(
                            (filter) =>
                                (!filter.CONTRACT_TYPE ||
                                    filter.CONTRACT_TYPE?.some((x) => x === contractType)) &&
                                (!filter.REGION || filter.REGION?.some((x) => x === region)) &&
                                (!filter.COUNTRY ||
                                    filter.COUNTRY?.some((x) => x === country)) &&
                                (!filter.AREA || filter.AREA?.some((x) => x === area)) &&
                                (!filter.SEGMENT ||
                                    filter.SEGMENT?.some((x) => x === segment)) &&
                                (!filter.SUBSEGMENT ||
                                    filter.SUBSEGMENT?.some((x) => x === subsegment)) &&
                                (!filter.MAX_PRICE ||
                                    filter.MAX_PRICE >= Number(contractPrice)) &&
                                (!filter.MIN_PRICE ||
                                    filter.MIN_PRICE < Number(contractPrice)) &&
                                (!filter.TAG || filter.TAG.every((tag) => tags?.includes(tag)))
                        ) &&
                        (!EXCEPTIONS ||
                            !EXCEPTIONS.some(
                                (filter) =>
                                    (!filter.CONTRACT_TYPE ||
                                        filter.CONTRACT_TYPE?.some((x) => x === contractType)) &&
                                    (!filter.REGION ||
                                        filter.REGION?.some((x) => x === region)) &&
                                    (!filter.COUNTRY ||
                                        filter.COUNTRY?.some((x) => x === country)) &&
                                    (!filter.AREA || filter.AREA?.some((x) => x === area)) &&
                                    (!filter.SEGMENT ||
                                        filter.SEGMENT?.some((x) => x === segment)) &&
                                    (!filter.SUBSEGMENT ||
                                        filter.SUBSEGMENT?.some((x) => x === subsegment)) &&
                                    (!filter.MAX_PRICE ||
                                        filter.MAX_PRICE >= Number(contractPrice)) &&
                                    (!filter.MIN_PRICE ||
                                        filter.MIN_PRICE < Number(contractPrice)) &&
                                    (   !filter.TAG ||
                                        filter.TAG.every((tag) => tags?.includes(tag)))
                            ))
                )
                    .flatMap((x) => x.ITEMS)
                    .filter(function (v, i, s) {
                        return s.map((x) => x.EMAIL).indexOf(v.EMAIL) == i;
                    });

                return filteredItems;
            };
        },

        GetSigneesSelects: function (state, getters) {
            return (
                region,
                country,
                area,
                segment,
                subsegment,
                contractType,
                contractPrice,
                tags
            ) => {
                return (
                    getters
                        .GetSignees(
                            region,
                            country,
                            area,
                            segment,
                            subsegment,
                            contractType,
                            contractPrice,
                            tags
                        )
                        .map(({ NAME, EMAIL }) => {
                            return { name: NAME, email: EMAIL };
                        }) || []
                )?.sort((a, b) => a.name.localeCompare(b.name));
            };
        },

        GetDueDiligence: function (state, getters) {
            return (counterParty) => {
                if (counterParty != null && counterParty != undefined) {
                    let counterName = counterParty == "01" ? "CLIENT" : "VENDOR";
                    return state.esignConfig.DUE_DILIGENCE[counterName];
                } else
                    return {
                        BODY: "",
                        CHECKS: [],
                        OPTIONS: [],
                        TITLE: "",
                    };
            };
        },
    },
};

const getRequiredApprovals = function (APPROVER_ITEMS,approvers, config, selected, area, segment, subsegment, country) {
    if (approvers && config && selected) {
        let approval = Object.entries(selected).map(([key, value]) =>
            config
                .find((config) => config.CODE == key)
                .VALUES.find((v) => v.CODE == value?.code)
        );
        let approversRes = approvers.map(
            ({
                NAME,
                CODE,
                APPROVERS,
                MANDATORY,
                ONLY_GREEN,
                APPROVAL_ROLES,
                TOOLTIP,
                TAGS
            }) => {
                let result = {
                    NAME,
                    CODE,
                    SELECTABLE_APPROVERS: APPROVER_ITEMS?.filter(
                        ({ FILTERS, EXCEPTIONS }) =>
                            FILTERS.some(
                                (filter) =>
                                    (!filter.COUNTRY ||
                                        filter.COUNTRY?.some((x) => x === country)) &&
                                    (!filter.AREA || filter.AREA?.some((x) => x === area)) &&
                                    (!filter.SEGMENT ||
                                        filter.SEGMENT?.some((x) => x === segment)) &&
                                    (!filter.SUBSEGMENT ||
                                        filter.SUBSEGMENT?.some((x) => x === subsegment)) 
                            ) &&
                            (!EXCEPTIONS ||
                                !EXCEPTIONS.some(
                                    (filter) =>
                                        (!filter.COUNTRY ||
                                            filter.COUNTRY?.some((x) => x === country)) &&
                                        (!filter.AREA || filter.AREA?.some((x) => x === area)) &&
                                        (!filter.SEGMENT ||
                                            filter.SEGMENT?.some((x) => x === segment)) &&
                                        (!filter.SUBSEGMENT ||
                                            filter.SUBSEGMENT?.some((x) => x === subsegment)) 
                            )) 
                    )
                    .flatMap((x) => x.ITEMS).filter(z => z.ROLE === CODE),
                    APPROVERS,
                    TOOLTIP,
                    APPROVAL:
                        approval.findIndex(
                            (aprvl) => aprvl && aprvl.APPROVAL?.includes(CODE)
                        ) !== -1,
                    MANDATORY: MANDATORY,
                    ONLY_GREEN: ONLY_GREEN,
                    APPROVAL_ROLES: APPROVAL_ROLES,
                    CAN_DELEGATE_TO:
                        approval
                            .filter((aprvl) => aprvl && aprvl.APPROVAL?.includes(CODE))
                            ?.map(({ ESCALABLE_TO }) => ESCALABLE_TO)
                            ?.reduce((p, c, i) => {
                                return p.concat(c || []);
                            }, []) || [], 
                    TAGS
                };

                return {
                    selectableApprovers:
                        result.SELECTABLE_APPROVERS?.map(({ NAME, EMAIL, TITLE }) => {
                            return {
                                name: NAME,
                                email: EMAIL,
                                title: TITLE,
                            };
                        }) || [],
                    name: result.NAME,
                    code: result.CODE,
                    mandatory: result.MANDATORY,
                    onlyGreen: result.ONLY_GREEN,
                    tooltip: result.TOOLTIP,
                    approval: result.APPROVAL,
                    canDelegateTo: result.CAN_DELEGATE_TO,
                    approvers: (
                        approvers.find((x) => x.CODE === result.CODE).APPROVERS || []
                    ).map(({ NAME, EMAIL }) => {
                        return { name: NAME, code: EMAIL };
                    }),
                    roleApproval: !!result.APPROVAL_ROLES?.length,
                    tags: result.TAGS,
                };
            }
        );

        return approversRes.map((appRes) => {
            return {
                ...appRes,
                canBeDelegated:
                    approversRes.findIndex((item) =>
                        item?.canDelegateTo?.includes(appRes.code)
                    ) !== -1,
            };
        });
    } else return [];
};

export default ESignJLLTConfigModule;
